// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__NOI1c","Modal__inner":"modal_Modal__inner__pWkpe","Modal__Dialog":"modal_Modal__Dialog__vC22b","transition":"modal_transition__SBht_"};